<h2 class="mb-4">{{ 'COMMON.CANDIDATES' | translate }} >> {{ 'CANDIDATES.FROMFILE' | translate }}</h2>
<div class="d-flex justify-content-between">
  <div class="btn btn-primary mb-3 backButton" (click)="utilsService.goBack()">
    <i class="fa fa-arrow-left" style="font-size: 15px;"></i> {{ 'COMMON.BACK' | translate | uppercase }}
  </div>

  <div class="btn btn-light mb-3 backButton" (click)="resetFile()" *ngIf="step === 'reviewCandidates'">
    {{ 'CANDIDATES.DELETEUPLOADFILE' | translate }}
  </div>
</div>

<div id="uploadCandidates" *ngIf="step === 'uploadCandidates'">
  <div id="fileCard" class="card mb-4 border-0 shadow-sm">
    <div class="card-body">
      <div class="form-row">
        <div class="form-group">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="candidatesFile" (change)="onFileSelect($event.target)">
            <label class="custom-file-label" for="candidatesFile" [attr.data-browse]="'COMMON.BROWSE' | translate">{{ fileName }}</label>
          </div>
          <small id="candidatesFileHelp" class="form-text text-muted" hidden>error</small>
        </div>
      </div>

      <div class="row mt-3">
        <h6>
          <a href="/assets/csv/candidates-template.csv" download><i class="fa fa-download"></i> {{ 'CANDIDATES.DOWNLOADTEMPLATE' | translate }}</a>
        </h6>
      </div>

      <div class="row mt-3">
        <h6>
          <span (click)="showModalEditInstructions()" class="link">{{'CANDIDATES.EDITCSVSHOW' | translate}}</span>
        </h6>
      </div>

      <div class="row mt-3">
        <h6>
          <strong>
            <span (click)="showModalLoadInstructions()" class="link">{{'CANDIDATES.LOADCSVSHOW' | translate}}</span>
          </strong>
        </h6>
      </div>
    </div>
  </div>
</div>

<div id="uploadCandidates" *ngIf="step === 'uploadCandidates' || step === 'reviewCandidates'">
  <div id="dataCard" class="card mb-4 border-0 shadow-sm">
    <div class="card-body">
      <div class="row my-4">
        <h6 class="text-danger" *ngIf="!candidates">{{ 'CANDIDATES.LOADFILETOSEE' | translate }}</h6>

        <ng-container *ngIf="candidates">
          <div class="d-flex justify-content-between">
            <div class="form-group ml-4 pl-3">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="toggleAll" (change)="toggleAllCandidates($event)" checked>
                <label class="custom-control-label" for="toggleAll">
                  {{ 'CANDIDATES.SELECTEDOF' | translate:{ x: getCheckedCandidates().length, y: candidates.length } }}
                </label>
              </div>
            </div>
            <div class="form-group ml-4 pl-3">
              <label *ngIf="filterErrors">
                {{ 'CANDIDATES.FILTERINGWRONGCANDIDATES' | translate }}. <span class="link" (click)="filterErrors = false">{{ 'CANDIDATES.REMOVEFILTER' | translate }}</span>
              </label>
            </div>
          </div>

          <table class="table table-borderless mx-5">
            <thead>
              <tr>
                <td></td>
                <td>{{ 'COMMON.NAME' | translate }}</td>
                <td>{{ 'COMMON.SURNAME' | translate }} 1</td>
                <td>{{ 'COMMON.SURNAME' | translate }} 2</td>
                <td>{{ 'COMMON.EMAIL' | translate }}</td>
                <td>{{ 'COMMON.DNI' | translate }}</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let candidate of candidatesFiltered() | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize"
                [ngClass]="{ 'table-danger': candidate.hasError, 'table-warning': candidate.hasWarning }"
              >
                <td><input class="form-check-input ml-0" type="checkbox" [checked]="candidate.checked" [disabled]="candidate.hasError" (click)="toggleCandidate(candidate)"></td>
                <td><input class="form-control trim" [(ngModel)]="candidate.name" (blur)="checkCandidateValidity(candidate)"></td>
                <td><input class="form-control trim" [(ngModel)]="candidate.surname1" (blur)="checkCandidateValidity(candidate)"></td>
                <td><input class="form-control trim" [(ngModel)]="candidate.surname2" (blur)="checkCandidateValidity(candidate)"></td>
                <td><input class="form-control trim" [(ngModel)]="candidate.email" (blur)="checkCandidateValidity(candidate)"></td>
                <td><input class="form-control trim" [(ngModel)]="candidate.idCard" (blur)="checkCandidateValidity(candidate)"></td>
              </tr>
            </tbody>
          </table>
          <ngb-pagination class="mx-auto" [(page)]="page" [pageSize]="pageSize" [collectionSize]="candidatesFiltered().length"></ngb-pagination>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="form-row" *ngIf="step === 'reviewCandidates'">
    <div class="col-md-4">
      <div class="form-group">
        <button type="button" class="btn btn-primary btn-block" *ngIf="errorCount() > 0" (click)="filterErrors = !filterErrors">
          {{ 'CANDIDATES.FILTERPOSSIBLEWRONGCANDIDATES' | translate }}
        </button>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <button type="button" class="btn btn-primary btn-block" *ngIf="errorCount() > 0" (click)="exportErrors()">
          {{ 'CANDIDATES.EXPORTPOSSIBLEWRONGCANDIDATES' | translate }}
        </button>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <button type="button" class="btn btn-primary btn-block" (click)="upload()">
          {{ 'CANDIDATES.CONFIRMSELECTEDCANDIDATES' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div id="candidatesUploadProgress" class="my-3" *ngIf="step === 'candidatesUploadProgress'">
  <div class="card mb-4 border-0 shadow-sm">
    <div class="card-body text-center p-5">
      <ngb-progressbar type="primary" height="20px" [striped]="true" [animated]="true" [value]="uploadProgress()">{{ uploadProgress() | number:'1.0-0' }}%</ngb-progressbar>
      <h4 class="mt-5 mb-3">{{ 'CANDIDATES.ESTIMATEDTIME' | translate }}: {{ estimatedTime() }}</h4>
      <h4>{{ 'COMMON.CANDIDATES' | translate }}: {{ allCandidates.flat().length }}/{{ totalCandidates }}</h4>
    </div>
  </div>
</div>

<div id="candidatesUploadResume" class="my-3" *ngIf="step === 'candidatesUploadResume'">
  <div class="card mb-4 border-0 shadow-sm">
    <div class="card-body text-center p-5">
      <div class="resume-icons">
        <i class="fa fa-check-circle fa-5x text-success"></i><span>{{ allCandidates.flat().length }}</span>
        <i class="fa fa-close fa-5x ml-5 text-danger"></i><span>{{ errorEmails.length }}</span>
      </div>
      <div>
        <p *ngIf="errorEmails.length">{{ 'CONSULTANT.SENDINVITATIONFAIL' | translate }}</p>
        <p *ngIf="!errorEmails.length">{{ 'CONSULTANT.CREATECANDIDATESUCCESS' | translate }}</p>
        <ul class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let email of errorEmails.slice(0, 5)">{{ email }}</li>
        </ul>
        <div *ngIf="errorEmails.length > 5">
          <p>
            <button type="button" class="btn btn-link p-0 box-shadow-none" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed">
              <ng-container *ngIf="!isCollapsed">{{ 'COMMON.SEELESS' | translate }}</ng-container>
              <ng-container *ngIf="isCollapsed">{{ 'COMMON.SEEMORE' | translate }}</ng-container>
            </button>
          </p>
          <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
            <ul class="list-group list-group-flush">
              <li class="list-group-item" *ngFor="let email of errorEmails.slice(5)">{{ email }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div [ngClass]="errorEmails.length < allCandidates.flat().length ? 'col-md-6' : 'col-md-6 offset-md-3'" *ngIf="errorEmails.length">
          <div class="form-group">
            <button type="button" class="btn btn-primary btn-block" (click)="exportErrors(errorEmails)">
              {{ 'CANDIDATES.EXPORTWRONGCANDIDATES' | translate }}
            </button>
          </div>
        </div>
        <div [ngClass]="errorEmails.length ? 'col-md-6' : 'col-md-6 offset-md-3'" *ngIf="errorEmails.length < allCandidates.flat().length">
          <div class="form-group">
            <button type="button" class="btn btn-primary btn-block" (click)="step = 'uploadTests'">
              <i class="fa fa-envelope"></i> {{ 'CANDIDATES.CHOOSETESTS' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="uploadTests" [hidden]="step !== 'uploadTests'">
  <ct-invite (inviteSent)="router.navigateByUrl('/consultant/candidates')"></ct-invite>
</div>

<ng-template #content let-modal>
  <div class="modal-header border-bottom-0">
    <h6 class="modal-title mx-auto">{{ 'CANDIDATES.EDITCSVTITLE' | translate }}</h6>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>&nbsp;
      </button>
    </div>
  </div>

  <div class="modal-body px-4 pt-0" [innerHtml]="'CANDIDATES.EDITCSVBODY' |translate">
  </div>
</ng-template>

<ng-template #loadInstructionsModal let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title mx-auto">{{ 'CANDIDATES.LOADCSVTITLE' | translate }}</h5>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>&nbsp;
      </button>
    </div>
  </div>

  <div class="modal-body px-4 pt-0" [innerHtml]="'CANDIDATES.LOADCSVBODY' | translate"></div>
</ng-template>

